import React from "react";
import { Outlet } from "react-router-dom"; 
import Footer from "./Landing_Page/Footer";
import Navigation from "./Landing_Page/Navigation";

const Layout = () => {
  // Remove the children prop
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow">
        <Outlet /> {/* Replace {children} with <Outlet /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
